export const DATA_INTELLIGENZ_URL = 'https://dataintelligenz.net';
